// Basit, tamamen client-side CSV dışa aktarım — backend'e gerek yok, tab zaten
// state'inde ekranda gösterdiği veriyi tutuyor, bu sadece onu bir dosyaya döküyor.
// Türkçe Excel'in ondalık ayracı virgül olduğu için ayraç noktalı virgül (;),
// ve Türkçe karakterlerin (ş/ğ/ü/ö/ç/ı) Excel'de bozulmaması için UTF-8 BOM ekleniyor.

export interface ExportColumn {
  key: string;
  label: string;
}

export function exportCsv(filename: string, rows: Record<string, any>[], columns: ExportColumn[]) {
  if (!rows || rows.length === 0) return;
  const esc = (v: any) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",;\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const header = columns.map(c => esc(c.label)).join(';');
  const lines = rows.map(r => columns.map(c => esc(r[c.key])).join(';'));
  const csv = '﻿' + [header, ...lines].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
